import { BookingMode, CalendarProvider } from '@lyrahealth-inc/shared-app-logic/src/models/calendar/CalendarV2'

import { RoleConfig } from '../../common/roleConfigs'

export const useProviderCalendarLive = (
  config: RoleConfig | undefined,
  calendarProvider: CalendarProvider | undefined,
) => {
  if (!calendarProvider) {
    return false
  }
  // return true for any of the bend modes independently of the hybridBookingMode
  if (
    [BookingMode.BOOKABLE_BLOCK, BookingMode.HYBRID_BLOCK, BookingMode.HYBRID_MANAGED].includes(
      calendarProvider.booking_mode,
    )
  ) {
    return true
  }
  return config?.inProductCalendar?.hybridBookingMode
    ? calendarProvider?.booking_mode === BookingMode.HYBRID
    : calendarProvider?.booking_mode === BookingMode.BOOKABLE
}
